module.exports = __webpack_public_path__ + "static/img/4设计师1.bcddd94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/4设计师1.png
// module id = K9mw
// module chunks = 1